import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private msalService: MsalService) {}

  getIdToken() {
    return localStorage.getItem('dreamAzureIdToken');
  }

  getaccessToken() {
    return localStorage.getItem('dreamAzureAccessToken');
  }

  getazureId() {
    return localStorage.getItem('dreamAzureId');
  }

  areTokensExpired(): boolean {
    const idToken = this.getIdToken();
    const accessToken = this.getaccessToken();

    if (!idToken || !accessToken) {
      return true;
    }

    return this.isTokenExpired(idToken) || this.isTokenExpired(accessToken);
  }

  private isTokenExpired(token: string): boolean {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      return decodedToken.exp <= currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  }

  clearLocalStorage() {
    localStorage.removeItem('dreamAzureIdToken');
    localStorage.removeItem('dreamAzureAccessToken');
    localStorage.removeItem('dreamAzureId');
    localStorage.removeItem('dreamAzureEmail');
    // The stored profile (role included) belongs to the session that ended
    localStorage.removeItem('currentUserData');
  }

  login() {
    sessionStorage.clear();
    this.clearLocalStorage();
    this.msalService.initialize().subscribe({
      next: () => {
        this.msalService.loginRedirect();
      },
      error(err) {},
    });
  }
}
function jwtDecode(token: string): any {
  throw new Error('Function not implemented.');
}
